import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatInputModule } from '@angular/material/input';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { MatButtonModule } from '@angular/material/button';
import {
  MoldDialogCreateMoldService,
  MoldDialogCreateNamesForm,
} from './create-mold.service';
import { MoldType } from '../../../../api/elite/types/mold-type';
import { Subscription } from 'rxjs';
import { AssemblyItem } from 'src/app/api/elite/types/assembly-item';
import { MatAutocompleteModule } from '@angular/material/autocomplete';

@Component({
  selector: 'app-mold-dialog-create-mold',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatSlideToggleModule,
    MatInputModule,
    MatOptionModule,
    MatSelectModule,
    NgxMatSelectSearchModule,
    MatButtonModule,
    MatAutocompleteModule,
  ],
  templateUrl: './create-mold.component.html',
  styleUrls: ['./create-mold.component.sass'],
})
export class MoldDialogCreateMoldComponent implements OnInit, OnDestroy {
  @Output() finish = new EventEmitter<void>();

  get form(): FormGroup {
    return this.service.form;
  }

  get imageFileName(): string | null {
    return this.service.imageFileName;
  }

  showControls: { [key in MoldDialogCreateNamesForm]?: boolean } = {
    cavities: true,
    newMold: true,
    assembly: true,
  };

  get moldTypes(): MoldType[] {
    return this.service.moldTypes;
  }

  filteredOptions: AssemblyItem[] = [];
  moldsFiltered$ = this.service.moldsFiltered$;

  newMoldToggle = false;
  onEdit: boolean;

  private subscription: Subscription = new Subscription();

  constructor(private readonly service: MoldDialogCreateMoldService) {}

  ngOnInit(): void {
    this.subscription.add(
      this.form.get('newMold')!.valueChanges.subscribe((value) => {
        this.newMoldToggle = value;
      })
    );

    this.subscription.add(
      this.service.showControls$.subscribe((controls) => {
        this.showControls = controls;
      })
    );

    this.subscription.add(
      this.service.filteredAssembly$.subscribe((options) => {
        this.filteredOptions = options;
      })
    );

    this.onEdit = this.service.onEdit;
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  finishForm(): void {
    this.finish.emit();
  }

  onSearchInput(event: Event): void {
    const query = (event.target as HTMLInputElement).value;
    this.service.searchOptions(query);
  }

  onImageSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (!input.files || input.files.length === 0) return;

    const file = input.files[0];

    if (!file.type.startsWith('image/')) {
      input.value = '';
      return;
    }

    if (file.size > 5 * 1024 * 1024) {
      input.value = '';
      return;
    }

    this.service.setImage(file);
  }
}
